<template>
  <base-info-card title="Shippers">
    <a
      :text="'Sign Up'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Sign Up'"
    />
    <a
      :text="'Why Us ?'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Why Us ?'"
    />
    <a
      :text="'Pricing'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Pricing'"
    />
    <a
      :text="'Terms & Condition'"
      class="mb-8 grey--text body-1 d-block text-none"
      href="#"
      v-html="'&rsaquo; Terms & Condition'"
    />
    <a
      text
      small
      class="mb-8 grey--text body-1 d-block text-none"
      :href="'/reach-us'"
      v-html="'&rsaquo; Reach Us'"
    />
  </base-info-card>
</template>

<script>
export default {
  name: "SectionFeaturesAlt",

  data: () => ({
    features: [
      "Zero Installation",
      "Easy Customization",
      "User Friendly Design",
      "24/7 Support Desk",
      "SEO Optimized",
    ],
  }),
};
</script>
